import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Pull-style quote with attribution. Use for client/coach quotes,
 * book passages, or any "someone said this" moment.
 *
 *   "זה היה יום מטורף, ואני בלגן."
 *      — לקוחה, מפגש 4
 *
 * Routes from a blockquote that ends with a `— name` attribution line.
 */
export type QuoteCardProps = {
  children: ReactNode;
  attribution?: ReactNode;
  className?: string;
};

export function QuoteCard({ children, attribution, className }: QuoteCardProps) {
  return (
    <figure
      className={cn(
        "my-7 ps-6 border-s-2 border-stone-300/70",
        className,
      )}
    >
      <blockquote
        className={cn(
          "text-xl sm:text-2xl font-medium leading-snug tracking-tight",
          "text-stone-800 italic",
        )}
      >
        {children}
      </blockquote>
      {attribution ? (
        <figcaption className="mt-3 text-sm text-stone-500 not-italic">
          — {attribution}
        </figcaption>
      ) : null}
    </figure>
  );
}
